import { render, staticRenderFns } from "./ChooseSceneFolder.vue?vue&type=template&id=c8567126&scoped=true&"
import script from "./ChooseSceneFolder.vue?vue&type=script&lang=js&"
export * from "./ChooseSceneFolder.vue?vue&type=script&lang=js&"
import style0 from "./ChooseSceneFolder.vue?vue&type=style&index=0&id=c8567126&prod&scoped=true&lang=css&"
import style1 from "./ChooseSceneFolder.vue?vue&type=style&index=1&id=c8567126&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8567126",
  null
  
)

export default component.exports